import React, { useCallback } from 'react'
import './statsdetails.scss';
import Icon1  from '../../../assets/icons/1.svg';
import Icon2  from '../../../assets/icons/2.svg';
import Icon3  from '../../../assets/icons/3.svg';
import Usage from './usage';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getStats } from '../../../store/slices/projectSlice';
export default function Statsdetails() {
  const {stats,selectedProject}=useSelector((state)=>state.project)
  const dispatch=useDispatch()

  const getStates=useCallback((type)=>{
    const body={
      id: selectedProject?.id,
      filter_type:type
    }
    dispatch(getStats(body))
  },[dispatch, selectedProject])
  useEffect(()=>{
    getStates('Weekly')
  },[getStates])
  return (
    <div className='stats-details-all-contnet-alignment'>
      <div className='grid'>
        <div className='grid-items'>
            <img src={Icon1} alt="Icon1"/>
            <p>Estimate characters replied</p>
            <span>{stats?.total_chars || 0}</span>
        </div>
        <div className='grid-items'>
            <img src={Icon2} alt="Icon2"/>
            <p>Number of sessions</p>
            <span>{stats?.num_sessions || 0}</span>
        </div>
        <div className='grid-items'>
            <img src={Icon3} alt="Icon3"/>
            <p>Total messages served</p>
            <span>{stats?.num_questions || 0}</span>
        </div>
      </div>
      <Usage getStates={getStates}/>
    </div>
  )
}
